import { DEVELOPER_DASHBOARD_APP } from '../constants/webhookPermissions';

export function hasPermission(permissions, appCode, permissionCode) {
  return (permissions?.[appCode] ?? []).includes(permissionCode);
}

export function hasWebhookPermission(permissions, permissionCode) {
  return hasPermission(permissions, DEVELOPER_DASHBOARD_APP, permissionCode);
}

export function hasAnyWebhookPermission(permissions) {
  return (permissions?.[DEVELOPER_DASHBOARD_APP] ?? []).length > 0;
}
